import { Roles } from '@beable/roster-backend-client-v1';
import { Admin } from '../../interfaces/Admin';

export const emptyAdminProfile: Admin = {
    username: "",
    role: "",
    site: 1,
    id: "",
    password: "",
    lastLoginAt: ""
};


export const adminProfileFixture = (role?: Roles): Admin => {
    return {
        id: "e49efc60-b186-11ea-8783-e78f45faa9ds",
        username: "admin.user",
        role: role || Roles.beableadmin,
        site: 99,
        password: "password@3",
    };
};
  